import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/in-store-barcode"
    path="business/products/in-store-barcode"
    element={<AsyncPage />}
  />,
];
